/* eslint-disable @typescript-eslint/no-explicit-any */
import html2canvas from 'html2canvas';
import React, { createRef, useState } from 'react';
import { areEqual } from 'react-window';
import styled from 'styled-components';

import CheckIcon from 'components/icons/CheckIcon';

import { EditableTopicType } from '../../models';

export type SelectTopicItemProps = {
  index: number;
  style: React.CSSProperties;
  data: {
    items: EditableTopicType[];
    toggleItemActive: (id: string) => void;
  };
};

const SelectTopicItem = ({ data, index, style }: any) => {
  const ref = createRef<HTMLImageElement>();
  const [compressedImage, setCompressedImage] = useState('');

  const { items, toggleItemActive } = data;
  const item = items[Number(index)];

  const makeScreenshot = () => {
    html2canvas(ref.current as HTMLImageElement, {
      useCORS: true,
    }).then((canvas) => setCompressedImage(canvas.toDataURL()));
  };

  return (
    <div
      style={{
        ...style,
        left: '20px',
        width: '95%',
      }}
    >
      <Container>
        <InfoContainer>
          {compressedImage ? (
            <TopicImage src={compressedImage} />
          ) : (
            <TopicImage onLoad={makeScreenshot} ref={ref} src={item.imgUrl} />
          )}

          <div>
            <Title>{item.title}</Title>
            {item.numberOfItems && (
              <Items>
                <span>Items: </span>
                <p>{item.numberOfItems}</p>
              </Items>
            )}
          </div>
        </InfoContainer>
        <CheckContainer onClick={() => toggleItemActive(item.id)}>
          {item.isChosen && <CheckIcon />}
        </CheckContainer>
      </Container>
    </div>
  );
};

const TopicImage = styled.img`
  border-radius: 3px;
  width: 80px;
  object-fit: cover;
  height: 55px;
`;

const Title = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primary};
`;

const Items = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  top: 2px;

  span {
    font-size: 12px;
    opacity: 0.75;
  }

  p {
    font-size: 12px;
    opacity: 0.75;
    margin-top: 5px;
    font-weight: 700;
    margin-left: 2px;
  }
`;

const CheckContainer = styled.div`
  border-radius: 3px;
  border: 2px solid ${({ theme }) => theme.colors.funtainBlue};
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

const InfoContainer = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  position: relative;
  top: -1px;
`;

const Container = styled.div`
  width: 100%;
  height: 75px;
  box-sizing: border-box;
  padding: 10px 20px 10px 10px;
  box-shadow: 0 8px 15px 1px rgb(0 0 0 / 20%);
  border-radius: 4px;
  position: relative;
  margin-top: 20px;
`;

export default React.memo(SelectTopicItem, areEqual);
